
// Menu

export const OPEN_MENU = 'OPEN_MENU';
export const CLOSE_MENU = 'CLOSE_MENU';


// nav
export const FROM_PAGE = 'FROM_PAGE';

// key
export const SET_KEY = 'SET_KEY';
export const CHANGE_VALUE = 'CHANGE_VALUE';
export const RESET = 'RESET';

// tur
export const NEW_ANSWER = 'NEW_ANSWER';
export const SET_ANSWERS = 'SET_ANSWERS';
export const SET_TIME = 'SET_TIME';
export const GET_TIME = 'GET_TIME';



// WEBPACK FOOTER //
// ./actions/actionTypes.js